import { useEffect } from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

const show = () => {
  if (window?.Intercom?.booted) {
    window.Intercom('show')
  } else {
    window.open('mailto:support@pga.com')
  }
}

const showNewMessage = content => {
  if (window?.Intercom?.booted) {
    window.Intercom('showNewMessage', content)
  } else {
    window.open(`mailto:support@pga.com?body=${content}`)
  }
}

const startSurvey = surveyId => {
  if (window?.Intercom?.booted) {
    window.Intercom('startSurvey', surveyId)
  } else {
    window.open('mailto:support@pga.com')
  }
}

const hideLauncher = () => {
  if (window?.Intercom?.booted) {
    window.Intercom('update', { hide_default_launcher: true })
  }
}

const showLauncher = () => {
  if (window?.Intercom?.booted) {
    window.Intercom('update', { hide_default_launcher: false })
  }
}

const useHideIntercom = () => {
  useEffect(() => {
    hideLauncher()

    return () => showLauncher()
  })
}

const useHideMobileIntercom = (shouldHide = true) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'))

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    // Wait for the launcher to load (max 30 seconds).
    // Need to wait for the launcher to load in order to apply styles, otherwise
    // there is an error that prevents page loads.
    const timeout = setTimeout(() => clearInterval(interval), 30000)
    const interval = setInterval(() => {
      if (window?.Intercom?.booted) {
        // Add class to show the launcher
        if (isMobile && shouldHide) {
          hideLauncher()
        } else {
          showLauncher()
        }

        clearInterval(interval)
        clearTimeout(timeout)
      }
    }, 100)
  }, [isMobile])
  /* eslint-disable react-hooks/exhaustive-deps */
}

export {
  show,
  showNewMessage,
  useHideIntercom,
  useHideMobileIntercom,
  startSurvey,
}
